import {lazy} from "react";
import {createBrowserRouter, Navigate, Outlet, useParams} from "react-router";
import {Permissionable} from "@components/default/Permissionable.tsx";
import {LoginPage} from "@components/account/LoginPage.tsx";
import {RootProvider} from "@components/default/RootProvider.tsx";

/* eslint-disable react-refresh/only-export-components */

const IndexPage = lazy(() => import("@components/default/IndexPage.tsx").then(m => ({default: m.IndexPage})));
const NotasFiscaisEntradaPage = lazy(() => import("@components/fiscal/NotasFiscaisEntradaPage.tsx").then(m => ({default: m.NotasFiscaisEntradaPage})));
const NotaFiscalPage = lazy(() => import("@components/fiscal/NotaFiscalPage.tsx").then(m => ({default: m.NotaFiscalPage})));
const NotasFiscaisSaidaPage = lazy(() => import("@components/fiscal/NotasFiscaisSaidaPage.tsx").then(m => ({default: m.NotasFiscaisSaidaPage})));
const FornecedoresPage = lazy(() => import("@components/fornecedores/FornecedoresPage.tsx").then(m => ({default: m.FornecedoresPage})));
const FornecedorDetalhesPage = lazy(() => import("@components/fornecedores/FornecedorDetalhesPage.tsx").then(m => ({default: m.FornecedorDetalhesPage})));
const CaminhoesPage = lazy(() => import("@components/caminhoes/CaminhoesPage.tsx").then(m => ({default: m.CaminhoesPage})));
const CaminhaoPage = lazy(() => import("@components/caminhoes/CaminhaoPage.tsx").then(m => ({default: m.CaminhaoPage})));
const RepresentantesDetalhesPage = lazy(() => import("@components/representante/RepresentantesDetalhesPage.tsx").then(m => ({default: m.RepresentantesDetalhesPage})));
const RepresentanteDetalhesPage = lazy(() => import("@components/representante/RepresentanteDetalhesPage.tsx").then(m => ({default: m.RepresentanteDetalhesPage})));
const ProdutosPage = lazy(() => import("@components/produtos/ProdutosPage.tsx").then(m => ({default: m.ProdutosPage})));
const FamiliasPage = lazy(() => import("@components/produtos/FamiliasPage.tsx").then(m => ({default: m.FamiliasPage})));
const ColecoesPage = lazy(() => import("@components/produtos/ColecoesPage.tsx").then(m => ({default: m.ColecoesPage})));
const ProdutoPage = lazy(() => import("@components/produtos/ProdutoPage.tsx").then(m => ({default: m.ProdutoPage})));
const ClientesPage = lazy(() => import("@components/clientes/ClientesPage.tsx").then(m => ({default: m.ClientesPage})));
const ClienteDetalhesPage = lazy(() => import("@components/clientes/ClienteDetalhesPage.tsx").then(m => ({default: m.ClienteDetalhesPage})));
const ClientePrecoSearch = lazy(() => import("@components/clientes/ClientePrecoSearch.tsx").then(m => ({default: m.ClientePrecoSearch})));
const RegrasPage = lazy(() => import("@components/regras/RegrasPage.tsx").then(m => ({default: m.RegrasPage})));
const RegraPage = lazy(() => import("@components/regras/RegraPage.tsx").then(m => ({default: m.RegraPage})));
const TabelasPrecoPage = lazy(() => import("@components/tabelaspreco/TabelasPrecoPage.tsx").then(m => ({default: m.TabelasPrecoPage})));
const TabelaPrecoPage = lazy(() => import("@components/tabelaspreco/TabelaPrecoPage.tsx").then(m => ({default: m.TabelaPrecoPage})));
const PedidosGraphsPage = lazy(() => import("@components/pedidos/forcavendas/PedidosGraphsPage.tsx").then(m => ({default: m.PedidosGraphsPage})));
const FuncionariosPage = lazy(() => import("@components/funcionarios/FuncionariosPage.tsx").then(m => ({default: m.FuncionariosPage})));
const UsersPage = lazy(() => import("@components/users/UsersPage.tsx").then(m => ({default: m.UsersPage})));
const CreateUserPage = lazy(() => import("@components/users/CreateUserPage.tsx").then(m => ({default: m.CreateUserPage})));
const UserPage = lazy(() => import("@components/users/UserPage.tsx").then(m => ({default: m.UserPage})));
const RolesPage = lazy(() => import("@components/roles/RolesPage.tsx").then(m => ({default: m.RolesPage})));
const CreateRolePage = lazy(() => import("@components/roles/CreateRolePage.tsx").then(m => ({default: m.CreateRolePage})));
const EditRolePage = lazy(() => import("@components/roles/EditRolePage.tsx").then(m => ({default: m.EditRolePage})));
const RolePermissionsPage = lazy(() => import("@components/roles/RolePermissionsPage.tsx").then(m => ({default: m.RolePermissionsPage})));
const AlterarSenhaPage = lazy(() => import("@components/account/AlterarSenhaPage.tsx").then(m => ({default: m.AlterarSenhaPage})));
const GerarSenhaPage = lazy(() => import('@components/account/PwdGenerator.tsx').then(m => ({default: m.PwdGenerator})))
const PedidosVendaPage = lazy(() => import("@components/pedidos/venda/PedidosVendaListPage.tsx").then(m => ({default: m.PedidosVendaListPage})));
const PedidosVendaGraphsPage = lazy(() => import("@components/pedidos/venda/PedidosVendaGraphsPage.tsx").then(m => ({default: m.PedidosVendaGraphsPage})));
const PedidoVendaDetalhesPage = lazy(() => import("@components/pedidos/venda/PedidoVendaDetalhesPage.tsx").then(m => ({default: m.PedidoVendaDetalhesPage})));
const PedidosVendaItensPage = lazy(() => import("@components/pedidos/venda/PedidosVendaItensPage.tsx").then(m => ({default: m.PedidosVendaItensPage})));
const CargaPage = lazy(() => import("@components/pedidos/venda/CargaPage.tsx").then(m => ({default: m.CargaPage})));
const PageNotFound = lazy(() => import("@components/default/PageNotFound.tsx").then(m => ({default: m.PageNotFound})));
const SimulacaoCargaPage = lazy(() => import("@components/logistica/carga/simulacao/SimulacaoCargaPage.tsx").then(m => ({default: m.SimulacaoCargaPage})));
const PaletesPage = lazy(() => import("@components/caminhoes/paletes/PaletesPage.tsx").then(m => ({default: m.PaletesPage})));
const TabelaDbErpPage = lazy(() => import("@components/geral/TabelaDbErpPage.tsx").then(m => ({default: m.TabelaDbErpPage})));
const SimulacaoCargasListPage = lazy(() => import("@components/logistica/carga/simulacao/SimulacaoCargasListPage.tsx").then(m => ({default: m.SimulacaoCargasListPage})));
const DepositosListPage = lazy(() => import("@components/logistica/depositos/DepositosListPage.tsx").then(m => ({default: m.DepositosListPage})));
const ProporcaoVenda = lazy(() => import("@components/logistica/ProporcaoVenda.tsx").then(m => ({default: m.ProporcaoVenda})));
const DepositoDetalhesPage = lazy(() => import("@components/logistica/depositos/DepositoDetalhesPage.tsx").then(m => ({default: m.DepositoDetalhesPage})));
const TrilhaPedidoDash = lazy(() => import("@components/logistica/TrilhaPedidoDash.tsx").then(m => ({default: m.TrilhaPedidoDash})));
const CargaListPage = lazy(() => import("@components/logistica/carga/CargaListPage.tsx").then(m => ({default: m.CargaListPage})));
const CargaDetalhesListPage = lazy(() => import("@components/logistica/carga/CargaDetalhesListPage.tsx").then(m => ({default: m.CargaDetalhesListPage})));
const CargaDetalhesPage = lazy(() => import("@components/logistica/carga/CargaDetalhesPage.tsx").then(m => ({default: m.CargaDetalhesPage})));
const CargaKanbanPage = lazy(() => import("@components/logistica/carga/CargaKanbanPage.tsx").then(m => ({default: m.CargaKanbanPage})));
const TratamentoCarga = lazy(() => import("@components/logistica/carga/TratamentoCarga.tsx").then(m => ({default: m.TratamentoCarga})));
const StepsListPage = lazy(() => import("@components/geral/rastreio/StepsListPage.tsx").then(m => ({default: m.StepsListPage})));
const CargaScannerPage = lazy(() => import("@components/logistica/carga/CargaScannerPage.tsx").then(m => ({default: m.CargaScannerPage})));
const CargaProximaEtapaPage = lazy(() => import("@components/logistica/carga/CargaProximaEtapaPage.tsx").then(m => ({default: m.CargaProximaEtapaPage})));
const CargaGraphPage = lazy(() => import('@components/logistica/carga/CargaGraphPage.tsx').then(m => ({default: m.CargasGraphPage})))
const RequisicaoCompraListPage = lazy(() => import('@components/compras/RequisicaoEletronicaListPage.tsx').then(m => ({default: m.RequisicaoEletronicaListPage})));

function RedirectToDetailedCarga() {
	const {cargaId} = useParams();
	return <Navigate to={`/logistica/cargas/detalhes/${cargaId}`} replace/>;
}

export const router = createBrowserRouter([
	{
		path: '/',
		element: <RootProvider/>,
		children: [
			{
				index: true,
				element: <IndexPage/>
			},
			{
				path: 'logistica/cargas/etapas',
				element: <Permissionable permissions={[{modulo: 'logistica'}]}>
					<StepsListPage/>
				</Permissionable>,
				handle: {breadcrumb: 'Etapas de Rastreio'}
			},
			{
				element: <TratamentoCarga/>,
				path: 'tratamento-carga/:cargaId'
			},
			{
				path: 'erpdb',
				handle: {breadcrumb: 'Bd Erp', clickable: false},
				children: [
					{
						path: 'tabelas',
						element: <Permissionable
							permissions={[{modulo: 'bancoDeDados'}]}><TabelaDbErpPage/></Permissionable>,
						handle: {breadcrumb: 'Tabelas', clickable: true},
					},
				],
			},

			{
				path: 'nf',
				element: <Outlet/>,
				children: [
					{
						path: 'entrada',
						element: <Outlet/>,
						handle: {breadcrumb: 'NF Entrada'},
						children: [
							{
								index: true,
								element: <Permissionable
									permissions={[{modulo: 'notaFiscal'}]}><NotasFiscaisEntradaPage/></Permissionable>
							},
							{
								path: ':numeronf/:serie/:fornecedorId',
								element: <Permissionable permissions={[{modulo: 'notaFiscal'}]}><NotaFiscalPage
									type={'entrada'}/></Permissionable>,
								handle: {breadcrumb: 'Detalhes'}
							}
						]
					},
					{
						path: 'saida',
						element: <Outlet/>,
						handle: {breadcrumb: 'NF Saída'},
						children: [
							{
								index: true,
								element: <Permissionable permissions={[{modulo: 'notaFiscal'}]}><NotasFiscaisSaidaPage/></Permissionable>
							},
							{
								path: ':numeronf/:serie',
								element: <Permissionable permissions={[{modulo: 'notaFiscal'}]}><NotaFiscalPage
									type={'saida'}/></Permissionable>,
								handle: {breadcrumb: 'Detalhes'}
							}
						]
					}
				]
			},
			{
				path: 'fornecedores',
				element: <Outlet/>,
				handle: {breadcrumb: 'Fornecedores'},
				children: [
					{
						index: true,
						element: <Permissionable
							permissions={[{modulo: 'notaFiscal'}]}><FornecedoresPage/></Permissionable>
					},
					{
						path: ':id',
						element: <Permissionable
							permissions={[{modulo: 'notaFiscal'}]}><FornecedorDetalhesPage/></Permissionable>,
						handle: {breadcrumb: 'Detalhes'}
					}
				]
			},
			{
				path: 'caminhoes',
				element: <Outlet/>,
				handle: {breadcrumb: 'Caminhões'},
				children: [
					{
						index: true,
						element: <Permissionable permissions={[{modulo: 'caminhao'}]}><CaminhoesPage/></Permissionable>
					},
					{
						path: ':id',
						element: <Permissionable permissions={[{modulo: 'caminhao'}]}><CaminhaoPage/></Permissionable>,
						handle: {breadcrumb: 'Detalhes'}
					},
					{
						path: 'paletes',
						element: <PaletesPage/>,
						handle: {breadcrumb: 'Paletes'}
					}
				]
			},
			{
				path: 'representantes',
				element: <Outlet/>,
				handle: {breadcrumb: 'Representantes'},
				children: [
					{
						index: true,
						element: <Permissionable permissions={[{modulo: 'representante'}]}><RepresentantesDetalhesPage/></Permissionable>
					},
					{
						path: 'detalhes',
						element: <Permissionable permissions={[{modulo: 'representante'}]}><RepresentantesDetalhesPage/></Permissionable>,
						handle: {breadcrumb: 'Detalhes'}
					},
					{
						path: ':id',
						element: <Permissionable permissions={[{modulo: 'representante'}]}><RepresentanteDetalhesPage/></Permissionable>,
						handle: {breadcrumb: 'Detalhes'}
					}
				]
			},
			{
				path: 'produtos',
				element: <Outlet/>,
				handle: {breadcrumb: 'Produtos'},
				children: [
					{
						index: true,
						element: <Permissionable permissions={[{modulo: 'produto'}]}><ProdutosPage/></Permissionable>
					},
					{
						path: 'familias',
						element: <Permissionable permissions={[{modulo: 'produto'}]}><FamiliasPage/></Permissionable>,
						handle: {breadcrumb: 'Famílias'}
					},
					{
						path: 'colecoes',
						element: <Permissionable permissions={[{modulo: 'produto'}]}><ColecoesPage/></Permissionable>,
						handle: {breadcrumb: 'Coleções'}
					},
					{
						path: ':id',
						element: <Permissionable permissions={[{modulo: 'produto'}]}><ProdutoPage/></Permissionable>,
						handle: {breadcrumb: 'Detalhes'}
					}
				]
			},
			{
				path: 'clientes',
				element: <Outlet/>,
				handle: {breadcrumb: 'Clientes'},
				children: [
					{
						index: true,
						element: <Permissionable permissions={[{modulo: 'cliente'}]}><ClientesPage/></Permissionable>
					},
					{
						element: <Permissionable
							permissions={[{
								modulo: 'cliente',
								tipo: 'visualizar'
							}]}><ProporcaoVenda/></Permissionable>,
						path: 'ufs-atendimento'
					},
					{
						path: ':id',
						element: <Permissionable
							permissions={[{modulo: 'cliente'}]}><ClienteDetalhesPage/></Permissionable>,
						handle: {breadcrumb: 'Detalhes'}
					},
					{
						path: 'preco',
						element: <Permissionable
							permissions={[{modulo: 'cliente'}]}><ClientePrecoSearch/></Permissionable>,
						handle: {breadcrumb: 'Preço'}
					}
				]
			},
			{
				path: 'regras',
				element: <Outlet/>,
				handle: {breadcrumb: 'Regras'},
				children: [
					{
						index: true,
						element: <Permissionable permissions={[{modulo: 'regra'}]}><RegrasPage/></Permissionable>
					},
					{
						path: ':regraId',
						element: <Permissionable permissions={[{modulo: 'regra'}]}><RegraPage/></Permissionable>,
						handle: {breadcrumb: 'Detalhes'}
					}
				]
			},
			{
				path: 'tabelaprecos',
				element: <Outlet/>,
				handle: {breadcrumb: 'Tabelas de Preço'},
				children: [
					{
						index: true,
						element: <Permissionable
							permissions={[{modulo: 'produto'}, {modulo: 'cliente'}]}><TabelasPrecoPage/></Permissionable>
					},
					{
						path: ':id',
						element: <Permissionable
							permissions={[{modulo: 'produto'}, {modulo: 'cliente'}]}><TabelaPrecoPage/></Permissionable>,
						handle: {breadcrumb: 'Detalhes'}
					}
				]
			},
			{
				path: 'dashboards',
				element: <Outlet/>,
				children: [
					{
						path: 'pedidos',
						element: <Permissionable
							permissions={[{
								modulo: 'pedido',
								tipo: 'visualizarTudo'
							}]}><PedidosGraphsPage/></Permissionable>,
						handle: {breadcrumb: 'Dashboards > Pedidos'}
					},
					{
						path: 'cargas',
						element: <Permissionable
							permissions={[{
								modulo: 'pedido',
								tipo: 'visualizarTudo'
							}]}><TrilhaPedidoDash/></Permissionable>,
						handle: {breadcrumb: 'Dashboards > Pedidos'}
					}
				]
			},
			{
				path: 'Pessoas',
				element: <Outlet/>,
				handle: {breadcrumb: 'Funcionários'},
				children: [
					{
						index: true,
						element: <Permissionable
							permissions={[{
								modulo: 'colaboradores',
								tipo: 'visualizarTudo'
							}]}><FuncionariosPage/></Permissionable>
					}
				]
			},
			{
				path: 'login',
				element: <LoginPage/>
			},
			{
				path: 'usuarios',
				element: <Outlet/>,
				handle: {breadcrumb: 'Usuários'},
				children: [
					{
						index: true,
						element: <Permissionable permissions={[{modulo: 'usuario'}]}><UsersPage/></Permissionable>
					},
					{
						path: 'criar',
						element: <Permissionable permissions={[{modulo: 'usuario'}]}><CreateUserPage/></Permissionable>,
						handle: {breadcrumb: 'Novo'}
					},
					{
						path: ':usuarioId',
						element: <Permissionable permissions={[{modulo: 'usuario'}]}><UserPage/></Permissionable>,
						handle: {breadcrumb: 'Detalhes'}
					}
				]
			},
			{
				path: 'roles',
				element: <Outlet/>,
				handle: {breadcrumb: 'Roles'},
				children: [
					{
						index: true,
						element: <Permissionable permissions={[{modulo: 'role'}]}><RolesPage/></Permissionable>
					},
					{
						path: 'criar',
						element: <Permissionable permissions={[{modulo: 'role'}]}><CreateRolePage/></Permissionable>,
						handle: {breadcrumb: 'Novo'}
					},
					{
						path: ':id',
						element: <Permissionable permissions={[{modulo: 'role'}]}><EditRolePage/></Permissionable>,
						handle: {breadcrumb: 'Detalhes'}
					},
					{
						path: ':id/permissoes',
						element: <Permissionable
							permissions={[{modulo: 'role'}]}><RolePermissionsPage/></Permissionable>,
						handle: {breadcrumb: 'Permissões'}
					}
				]
			},
			{
				path: 'conta',
				element: <Outlet/>,
				children: [
					{
						path: 'alterarsenha',
						element: <AlterarSenhaPage/>,
						handle: {breadcrumb: 'Alterar Senha'}
					},
					{
						path: 'gerarsenha',
						element: <GerarSenhaPage/>,
						handle: {breadcrumb: 'Gerar Senha'}
					}
				]
			},
			{
				path: 'pedidos',
				element: <Outlet/>,
				// handle: {breadcrumb: 'Pedidos'},
				children: [
					{
						path: 'venda',
						element: <Outlet/>,
						handle: {breadcrumb: 'Venda'},
						children: [
							{
								index: true,
								element: <Permissionable
									permissions={[{
										modulo: 'pedido',
										tipo: 'visualizarTudo'
									}]}><PedidosVendaPage/></Permissionable>
							},
							{
								path: 'graficos',
								element: <Permissionable
									permissions={[{modulo: 'pedido', tipo: 'visualizarTudo'}]}><PedidosVendaGraphsPage/></Permissionable>,
								handle: {breadcrumb: 'Gráficos'}
							},
							{
								path: ':pedidoId/:filialId',
								element: <Permissionable
									permissions={[{
										modulo: 'pedido',
										tipo: 'visualizarTudo'
									}]}><PedidoVendaDetalhesPage/></Permissionable>,
								handle: {breadcrumb: 'Detalhes'}
							},
							{
								path: ':pedidoId/:filialId/itens',
								element: <Permissionable
									permissions={[{modulo: 'pedido', tipo: 'visualizarTudo'}]}><PedidosVendaItensPage/></Permissionable>,
								handle: {breadcrumb: 'Itens'}
							}
						]
					}
				]
			},
			{
				path: 'logistica/cargas',
				element: <Outlet/>,
				handle: {breadcrumb: 'Cargas'},
				children: [
					{
						index: true,
						element: <Permissionable permissions={[{modulo: "pedido"}, {modulo: 'logistica'}]}>
							<CargaListPage/>
						</Permissionable>,
					},
					{
						path: 'scanner',
						element: <Permissionable permissions={[{modulo: "pedido"}, {modulo: 'logistica'}]}>
							<CargaScannerPage/>
						</Permissionable>,
						handle: {breadcrumb: 'Escanear QR Code'}
					},
					{
						path: ':cargaId/proxima-etapa',
						element: <Permissionable permissions={[{modulo: "pedido"}, {modulo: 'logistica'}]}>
							<CargaProximaEtapaPage/>
						</Permissionable>,
						handle: {breadcrumb: 'Próxima Etapa'}
					},
					{
						path: ':filialId/:analiseId/:prefaturaId?',
						element: <Permissionable permissions={[{modulo: 'pedido'}, {modulo: "logistica"}]}>
							<CargaPage/>
						</Permissionable>,
						handle: {breadcrumb: 'Carga'}
					},
					{
						path: 'detalhes',
						element: <Outlet/>,
						handle: {breadcrumb: 'Cargas Detalhadas'},
						children: [
							{
								index: true,
								element: <Permissionable permissions={[{modulo: "pedido"}, {modulo: 'logistica'}]}>
									<CargaDetalhesListPage/>
								</Permissionable>,
							},
							{
								path: ':cargaId',
								element: <Permissionable permissions={[{modulo: 'pedido'}, {modulo: "logistica"}]}>
									<CargaDetalhesPage/>
								</Permissionable>,
								handle: {breadcrumb: 'Detalhes da Carga'}
							},
							{
								path: 'graph',
								element: <Permissionable permissions={[{modulo: 'pedido'}, {modulo: "logistica"}]}>
									<CargaGraphPage/>
								</Permissionable>,
								handle: {breadcrumb: 'Grafico de agendamento de cargas'}
							}
						]
					},
					{
						path: 'kanban',
						element: <Permissionable permissions={[{modulo: "pedido"}, {modulo: 'logistica'}]}>
							<CargaKanbanPage/>
						</Permissionable>,
						handle: {breadcrumb: 'Kanban de Cargas'}
					},
					{
						path: 'simulacoes',
						element: <Outlet/>,
						handle: {breadcrumb: 'Simulações de carga'},
						children: [
							{
								index: true,
								element: <Permissionable permissions={[{modulo: 'logistica'}]}>
									<SimulacaoCargasListPage/>
								</Permissionable>,
							},
							{
								path: ':simulacaoId',
								element: <Permissionable permissions={[{modulo: 'logistica'}]}>
									<SimulacaoCargaPage/>
								</Permissionable>,
								handle: {breadcrumb: 'Simulação de carga'}
							}
						]
					},
				]
			},
			{
				path: 'logistica/cargas/:cargaId',
				element: <RedirectToDetailedCarga/>
			},
			{
				path: 'logistica/depositos',
				element: <Outlet/>,
				handle: {breadcrumb: 'Depósitos'},
				children: [
					{
						index: true,
						element: <Permissionable permissions={[{modulo: 'logistica'}]}>
							<DepositosListPage/>
						</Permissionable>,
					},
					{
						path: ':depositoId',
						element: <Permissionable permissions={[{modulo: 'logistica'}]}>
							<DepositoDetalhesPage/>
						</Permissionable>,
						handle: {breadcrumb: 'Detalhes'}
					}
				]
			},
			{
				path: 'compras',
				element: <Permissionable
					permissions={[{modulo: 'compras'}]}><RequisicaoCompraListPage/></Permissionable>
			},
			{
				path: '*',
				element: <PageNotFound/>
			}
		]
	}
]);